var map = {
	"./Projekt-ONTA-1": "wz8m",
	"./Projekt-ONTA-1.json": "wz8m",
	"./Projekt-ONTA-2": "5Vj+",
	"./Projekt-ONTA-2.json": "5Vj+",
	"./burger": "pGop",
	"./burger.json": "pGop",
	"./machine": "wRUL",
	"./machine-mobile": "kvyM",
	"./machine-mobile.json": "kvyM",
	"./machine-nah": "yMfH",
	"./machine-nah-mobile": "UQIn",
	"./machine-nah-mobile.json": "UQIn",
	"./machine-nah.json": "yMfH",
	"./machine.json": "wRUL",
	"./people/alexander-hoffmann": "x/wf",
	"./people/alexander-hoffmann.json": "x/wf",
	"./people/andré-kutze": "gIr8",
	"./people/andré-kutze.json": "gIr8",
	"./people/bartlomiej-strauchman": "5UuS",
	"./people/bartlomiej-strauchman.json": "5UuS",
	"./people/christian-eilts": "Eru/",
	"./people/christian-eilts.json": "Eru/",
	"./people/christian-thode": "yh0X",
	"./people/christian-thode.json": "yh0X",
	"./people/christopher-marks": "Q9ym",
	"./people/christopher-marks.json": "Q9ym",
	"./people/dean-eckert": "Sjlj",
	"./people/dean-eckert.json": "Sjlj",
	"./people/dirk-klaene": "cWaZ",
	"./people/dirk-klaene.json": "cWaZ",
	"./people/ernst-stimmer": "Lm3p",
	"./people/ernst-stimmer.json": "Lm3p",
	"./people/felix-krueger": "M26M",
	"./people/felix-krueger.json": "M26M",
	"./people/holger-besdin": "gY7n",
	"./people/holger-besdin.json": "gY7n",
	"./people/jasmin-passier": "iw0O",
	"./people/jasmin-passier.json": "iw0O",
	"./people/julia-bajohr": "Pmom",
	"./people/julia-bajohr.json": "Pmom",
	"./people/marcel-heuser": "sP19",
	"./people/marcel-heuser.json": "sP19",
	"./people/marco-bunge": "AElc",
	"./people/marco-bunge.json": "AElc",
	"./people/markos-karapatsios": "ErkT",
	"./people/markos-karapatsios.json": "ErkT",
	"./people/markus-gaedicke": "2515",
	"./people/markus-gaedicke.json": "2515",
	"./people/maryam-seyedi": "n99F",
	"./people/maryam-seyedi.json": "n99F",
	"./people/matthias-geske": "/JPS",
	"./people/matthias-geske.json": "/JPS",
	"./people/maximilian-umbach": "lHde",
	"./people/maximilian-umbach.json": "lHde",
	"./people/michael-blank": "t239",
	"./people/michael-blank.json": "t239",
	"./people/muhammed-bulut": "Fh9l",
	"./people/muhammed-bulut.json": "Fh9l",
	"./people/niklas-berendt": "hiaV",
	"./people/niklas-berendt.json": "hiaV",
	"./people/nina-sandschulte": "uEF0",
	"./people/nina-sandschulte.json": "uEF0",
	"./people/philipp-hentschel": "aomD",
	"./people/philipp-hentschel.json": "aomD",
	"./people/robin-wloka": "2Z0H",
	"./people/robin-wloka.json": "2Z0H",
	"./people/sandra-quoll": "9lsc",
	"./people/sandra-quoll.json": "9lsc",
	"./people/shantanu-metkar": "8Q0U",
	"./people/shantanu-metkar.json": "8Q0U",
	"./people/stefan-benken": "WlaC",
	"./people/stefan-benken.json": "WlaC",
	"./people/stephan-krauss": "MlP5",
	"./people/stephan-krauss.json": "MlP5",
	"./people/sven-junga": "aKIR",
	"./people/sven-junga.json": "aKIR",
	"./people/thomas-mueller": "9tUd",
	"./people/thomas-mueller.json": "9tUd",
	"./people/tobias-kurzydym": "XQbH",
	"./people/tobias-kurzydym.json": "XQbH",
	"./people/tobias-stoehr": "Umlh",
	"./people/tobias-stoehr.json": "Umlh",
	"./people/ubeydullah-lapcin": "b9f+",
	"./people/ubeydullah-lapcin.json": "b9f+",
	"./people/vivien-schindler": "i4ED",
	"./people/vivien-schindler.json": "i4ED",
	"./people/volker-seibt": "noXQ",
	"./people/volker-seibt.json": "noXQ",
	"./services/coaching": "y2aC",
	"./services/coaching.json": "y2aC",
	"./services/development": "yQVo",
	"./services/development.json": "yQVo",
	"./services/mainframe": "4xdO",
	"./services/mainframe.json": "4xdO",
	"./services/mvp-prototyping": "jhLA",
	"./services/mvp-prototyping.json": "jhLA",
	"./services/prototyping": "qIQo",
	"./services/prototyping.json": "qIQo"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "632A";